import { Component, ElementRef, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Booking } from 'src/app/theBookableServices/models/booking.model';
import { Order, OrderLine } from 'src/app/theBookableServices/models/order.model';
import { OrdersService } from 'src/app/theBookableServices/services/orders/orders.service';
import { environment } from 'src/environments/environment';
import { BasketService } from '../../orders/basket.service';
// import { Booking } from 'src/app/models/booking.model';
// import { Order, OrderLine } from 'src/app/models/order.model';
// import { BasketService } from 'src/app/modules-ll/orders/basket.service';
// import { OrdersService } from 'src/app/modules-ll/orders/orders.service';

declare var paypal: any;

@Component({
  selector: 'app-pay-pal-pay',
  templateUrl: './pay-pal-pay.component.html',
  styleUrls: ['./pay-pal-pay.component.scss']
})
export class PayPalPayComponent implements OnInit {
  @ViewChild('paypal', { static: true }) paypalElement: ElementRef;
  @Output() payPalPayCompleteEvent: EventEmitter<any> = new EventEmitter();
  unpaidOrders: Order[] = [];
  @Input() totalPrice: number;
  @Input() order: Order;
  @Input() payg = false;
  @Input() bookingWithOrders$: Observable<Booking[]>;
  public totalValue = 0;
  paidFor = false;
  public subscription: Subscription = new Subscription();
  private orderLines: OrderLine[] = [];
  currency: string;

  constructor(
    private ordersService: OrdersService,
    private basketService: BasketService
  ) { }

  ngOnInit(): void {

    this.currency = environment.currency;
    this.currency = 'GBP';
    this.payPalPayCompleteEvent.subscribe((data) => {
    });

    // If I am a payg site, then need to listen for changes to the line items
    // Else I can wait and push the complete booking to get the orders
    if (this.payg) {
      this.subscription = this.basketService.orderLinesRef
        .subscribe((orderLines) => {

          this.orderLines = [];

          orderLines.forEach((orderLine: any) => {
            console.log('>>>>>>>>>>>>>>> PayPalPayComponent orderLine', orderLine);
            this.orderLines.push(orderLine);
          });

        });
    } else {

      this.bookingWithOrders$.subscribe((bookings: any[]) => {
        console.log('ordersordersordersorders', bookings);

        this.unpaidOrders = [];

        bookings.forEach((booking) => {

          console.log('booking', booking.orders);
          console.log('booking', booking.orders.length);


          // zip throu the orders looking for unpaid orders
          Object.entries(booking.orders).forEach(
            ([key, value]: any) => {
              console.log('valuevaluevaluevaluevalue', value);

              if (value.paymentStatus === false) {
                this.unpaidOrders.push(value);
              }
            }


          );


        });

      });

    }


    paypal.Buttons({
      createOrder: (data: any, actions: any) => {

        this.payPalPrePayment();

        return actions.order.create({
          purchase_units: [{
            description: 'Payment for goods at WetherPlates',
            amount: {
              currency_code: this.currency,
              value: this.totalValue
            }
          }]
        });
      },
      onApprove: async (data: any, actions: any) => {
        const order = await actions.order.capture();
        this.paidFor = true;
        console.log('order approved on paypal', data);

        this.payPalPostPayment();


      },
      onError: ((err: any) => {
        console.log('error: ' + err);
      })

    }).render(this.paypalElement.nativeElement);
  }


  payPalPrePayment() {

    let totalCost = 0;
    this.unpaidOrders.forEach((order: Order) => {

      order.orderLines.forEach((orderLine) => {
        const orderLineCost = orderLine.cost * orderLine.quantity;
        totalCost += orderLineCost;
      });

    });

    // If no data via subscribtions, then it has come from the basket, so accumulate from those items
    if (totalCost === 0) {
      this.orderLines.forEach((orderLine) => {
        const orderLineCost = orderLine.cost * orderLine.quantity;
        totalCost += orderLineCost;
      });
    }

    this.totalValue = Number(this.totalPrice.toFixed(2));
    console.log('this.totalValue', this.totalValue);

  }

  payPalPostPayment() {

    // console.log("this.unpaidOrdersthis.unpaidOrdersthis.unpaidOrders", this.unpaidOrders)

    // No need as we do this in addOrder,
    // Yep we do, for non payg
    this.unpaidOrders.forEach((order: Order) => {
      order.paymentStatus = true;
      this.ordersService.updatePaidtatus(order)
        .then(() => {
          console.log('order updated', order);
        });
    });

    // Notify subscribers.
    const o = Object.assign({}, { time: new Date(), unpaidOrders: this.unpaidOrders });
    this.payPalPayCompleteEvent.emit(o);

  }

}
